<script>
import ResourceService from '@/services/resources/sites_service';
import AdminView from './AdminView.vue';

export default {
  extends: AdminView,
  components: {
    ActionBar: () => import('@/components/action_bars/SitesActionBar.vue'),
  },
  data() {
    return {
      resourceService: ResourceService,
      icon: 'mdi-office-building',
      urlFragment: 'sites',
      resourceParams: {
        include: 'chemical-manufacturer',
      },
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Address', value: 'address' },
        { text: 'State', value: 'state' },
        { text: 'Manufacturer', value: 'chemicalManufacturer.name' },
      ],
      sortBy: ['name'],
    };
  },
};
</script>
